import { findRouterByRouteId } from "@/flow/utils/routerUtils";

function findStepInSteps(
  steps: any[],
  predicate: (step: any) => boolean
): any | null {
  if (!Array.isArray(steps)) return null;
  // eslint-disable-next-line
  for (const step of steps) {
    if (predicate(step)) return step;

    if (Array.isArray(step.steps)) {
      const found = findStepInSteps(step.steps, predicate);
      if (found) return found;
    }

    if (step.type === "ROUTER" && Array.isArray(step.routes)) {
      // eslint-disable-next-line
      for (const route of step.routes) {
        const found = findStepInSteps(route.steps || [], predicate);
        if (found) return found;
      }
    }
  }

  return null;
}

export function findStepForSelection(
  stepList: any[],
  selected: any
): any | null {
  if (!Array.isArray(stepList) || !selected) return null;

  if (selected.parentId) {
    const router = findRouterByRouteId(stepList, selected.parentId);
    const route = router?.routes?.find((r: any) => r?.id === selected.parentId);
    if (route?.steps) {
      const inRoute = findStepInSteps(
        route.steps,
        (step) =>
          (selected.origId && step.origId === selected.origId) ||
          (selected.id && step.id === selected.id)
      );
      if (inRoute) return inRoute;
    }
  }

  if (selected.origId) {
    const byOrigId = findStepInSteps(
      stepList,
      (step) => step.origId === selected.origId
    );
    if (byOrigId) return byOrigId;
  }

  if (selected.id) {
    const byId = findStepInSteps(stepList, (step) => step.id === selected.id);
    if (byId) return byId;
  }

  if (selected.uniqueId !== undefined && selected.uniqueId !== null) {
    const targetUniqueId = String(selected.uniqueId);
    const byUniqueId = findStepInSteps(
      stepList,
      (step) => String(step?.uniqueId) === targetUniqueId
    );
    if (byUniqueId) return byUniqueId;
  }

  return null;
}
